import { useApi } from "@lending/lib/api";

function usePatchPersonalLoanApplicationQuery() {
  const $api = useApi();

  return $api.useMutation("patch", "/v2/lending/personal_loan_applications/{uuid}/");
}

export { usePatchPersonalLoanApplicationQuery };
